<div *ngIf="showProgressBar">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div align="center" class="title">
  <h3>APU Visit</h3>
  <b>Supply Name: </b>{{supplyName}} &nbsp;
  &nbsp;
  <b>Location: </b> {{sysContact}}
  <br>
  <b>Location Information: </b> {{sysLocation}} &nbsp;
</div>
<br>
<mat-dialog-content class="mat-typography" align="center">
  <div>
    <form id="apuVisitFormGroup" [formGroup]="apuVisitFormGroup">
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput [matDatepicker]="picker" placeholder="Inspection Date" formControlName="inspectionDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput placeholder="APU Visit completed by Tech" formControlName="apuVisitedTech">
      </mat-form-field>
      <div class="col-md-12">
        <div class="col-md-4 data">
          <span class="formTitle">APU Starter Battery</span>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="APU Battery Manufacturer/Type" formControlName="apuBatteryManuType">
              <mat-option *ngFor="let apuBatteryManuType of apuBatteryManuTypes" [value]="apuBatteryManuType">
                {{apuBatteryManuType}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="APU Battery Date Code" formControlName="apuBatteryDateCode">
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput [matDatepicker]="picker1" placeholder="APU Battery Install Date"
              formControlName="apuBatteryInstallDate">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="APU Battery Voltage - No Load" formControlName="apuBatteryVltgNoLoad">
            <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryVltgNoLoad').errors?.validateNumber">
              APU Battery Voltage - No Load <strong>Should</strong> only include numbers !!
            </mat-error>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="APU Battery Conductance (mhos)" formControlName="apuBatteryConductance">
            <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryConductance').errors?.validateNumber">
              APU Battery Conductance <strong>Should</strong> only include numbers !!
            </mat-error>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="APU Battery Conductance - Corrected to 77deg F"
              formControlName="apuBatteryCon77deg">
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="APU Battery Torque in LBS" formControlName="apuBatteryTorque">
            <mat-error *ngIf="apuVisitFormGroup.get('apuBatteryTorque').errors?.validateNumber">
              APU Battery Torque <strong>Should</strong> only include numbers !!
            </mat-error>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="APU Battery Terminals cleaned" formControlName="apuBatteryTerminals">
              <mat-option *ngFor="let apuBatteryTerminal of apuBatteryTerminals" [value]="apuBatteryTerminal">
                {{apuBatteryTerminal}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="APU Starter battery charger Voltage" formControlName="apuStarter">
            <mat-error *ngIf="apuVisitFormGroup.get('apuStarter').errors?.validateNumber">
              APU Starter battery charger Voltage <strong>Should</strong> only include numbers !!
            </mat-error>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="APU Charger current (amps)" formControlName="apuCharger">
            <mat-error *ngIf="apuVisitFormGroup.get('apuCharger').errors?.validateNumber">
              APU Charger current <strong>Should</strong> only include numbers !!
            </mat-error>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Follow Up Action Needed" formControlName="followup">
              <mat-option *ngFor="let followup of followups" [value]="followup">
                {{followup}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="Record as found alarms" formControlName="recordAsFoundAlarms">
          </mat-form-field>
        </div>
        <div class="col-md-4 data">
          <span class="formTitle">APU</span>
          <br>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="APU test run (10 min under load)" formControlName="apuTestRun">
              <mat-option *ngFor="let apuTestRun of apuTestRuns" [value]="apuTestRun">
                {{apuTestRun}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Check Oil Level" formControlName="checkOilLevel">
              <mat-option *ngFor="let checkOilLevel of checkOilLevels" [value]="checkOilLevel">
                {{checkOilLevel}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="If Oil Added; Amount" formControlName="ifOilAdded">
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Oil Filter Tight" formControlName="oilFilterTight">
              <mat-option *ngFor="let oilFilterTight of oilFilterTights" [value]="oilFilterTight">
                {{oilFilterTight}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Inspect Generator Air Filter" formControlName="inspectGenerator">
              <mat-option *ngFor="let inspectGenerator of inspectGenerators" [value]="inspectGenerator">
                {{inspectGenerator}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Inspect Spark Plug" formControlName="inspectSparkPlug">
              <mat-option *ngFor="let inspectSparkPlug of inspectSparkPlugs" [value]="inspectSparkPlug">
                {{inspectSparkPlug}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Clear APU event log" formControlName="clearApuEventlog">
              <mat-option *ngFor="let clearApuEventlog of clearApuEventlogs" [value]="clearApuEventlog">
                {{clearApuEventlog}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="APU Frequency (hz)" formControlName="apuFrequency">
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="Tank # 1 (Level - If LP)" formControlName="tank1">
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="Tank # 2 (Level - If LP)" formControlName="tank2">
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="Gas Meter # (If NG gas)" formControlName="gasMeter">
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="Gas Meter reading (If NG gas)" formControlName="gasMeterReading">
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="NG Pressure" formControlName="ngPressure">
          </mat-form-field>
        </div>
        <div class="col-md-4 data">
          <span class="formTitle">Enclosure/PAD</span>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Change/clean enclosure air filter" formControlName="airFilter">
              <mat-option *ngFor="let airFilter of airFilters" [value]="airFilter">
                {{airFilter}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Check for rodent/insect damage" formControlName="rodentInsectDamage">
              <mat-option *ngFor="let rodentInsectDamage of rodentInsectDamages" [value]="rodentInsectDamage">
                {{rodentInsectDamage}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Check Lamps & LED" formControlName="checkLamps">
              <mat-option *ngFor="let checkLamp of checkLamps" [value]="checkLamp">
                {{checkLamp}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Clear weeds back 36 Inches if ground mount unit" formControlName="clearWeeds">
              <mat-option *ngFor="let clearWeed of clearWeeds" [value]="clearWeed">
                {{clearWeed}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Check & re-grout pad conduit openings as needed" formControlName="checkRegrout">
              <mat-option *ngFor="let checkRegrout of checkRegrouts" [value]="checkRegrout">
                {{checkRegrout}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="If Ground Mount Any pad undermining" formControlName="ifGroundMount">
              <mat-option *ngFor="let ifGroundMount of ifGroundMounts" [value]="ifGroundMount">
                {{ifGroundMount}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Any enclosure damage or Vandalism" formControlName="anyEnclosure">
              <mat-option *ngFor="let anyEnclosure of anyEnclosures" [value]="anyEnclosure">
                {{anyEnclosure}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Clean up garbage with in immediate vicinity" formControlName="cleanUpGarbage">
              <mat-option *ngFor="let cleanUpGarbage of cleanUpGarbages" [value]="cleanUpGarbage">
                {{cleanUpGarbage}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Test Oil pressure alarm" formControlName="testOilPressure">
              <mat-option *ngFor="let testOilPressure of testOilPressures" [value]="testOilPressure">
                {{testOilPressure}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Test High Temperature Alarm" formControlName="testhighTemp">
              <mat-option *ngFor="let testhighTemp of testhighTemps" [value]="testhighTemp">
                {{testhighTemp}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Generator DC Bus function" formControlName="generatorDcBus">
              <mat-option *ngFor="let generatorDcBus of generatorDcBuses" [value]="generatorDcBus">
                {{generatorDcBus}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Check for gas leaks" formControlName="checkForGas">
              <mat-option *ngFor="let checkForGas of checkForGases" [value]="checkForGas">
                {{checkForGas}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Test Combustible Gas Alarm" formControlName="testCombustible">
              <mat-option *ngFor="let testCombustible of testCombustibles" [value]="testCombustible">
                {{testCombustible}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Test Tamper alarm" formControlName="testTamper">
              <mat-option *ngFor="let testTamper of testTampers" [value]="testTamper">
                {{testTamper}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="If ground mount Test Water Intrusion Alarm" formControlName="testWaterIntrusion">
              <mat-option *ngFor="let testWaterIntrusion of testWaterIntrusions" [value]="testWaterIntrusion">
                {{testWaterIntrusion}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="If ground mount Test Pad Shear Alarm" formControlName="testPad">
              <mat-option *ngFor="let testPad of testPads" [value]="testPad">
                {{testPad}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <mat-form-field class="comments">
        <mat-label>APU Visit Comments</mat-label>
        <textarea matInput rows="3" formControlName="comments"></textarea>
        <mat-error *ngIf="apuVisitFormGroup.get('comments').errors?.maxlength">
          Comments can <strong>Maximum</strong> 255 Characters
        </mat-error>
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-button cdkFocusInitial [disabled]="apuVisitFormGroup.invalid" (click)="saveApuVisitChanges()">Save APU
    Visit Changes</button>
</mat-dialog-actions>